import html2canvas from "html2canvas";

export const canvasToBlob = (canvas) =>
    new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if (blob) {
                resolve(blob);
            } else {
                reject(new Error("No se pudo generar la imagen"));
            }
        }, "image/png");
    });

export const downloadBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 60000);
};

// useCORS: sin esto html2canvas descarta las imagenes de otro origen (logo
// del tenant en el bucket). backgroundColor fijo: el canvas no hereda el
// fondo del tema oscuro del portal.
// Se captura una copia colgada directo de <body>: dentro del arbol de la app
// (vue-fragment en App.vue, AppDialog con scroll) html2canvas fallaba con
// "Unable to find element in cloned iframe".
export const elementToCanvas = async (element) => {
    if (!element) {
        throw new Error("No se encontró el contenido a capturar");
    }
    const container = document.createElement("div");
    container.style.cssText =
        "position:fixed;top:0;left:0;z-index:-1;pointer-events:none;";
    container.appendChild(element.cloneNode(true));
    document.body.appendChild(container);
    try {
        return await html2canvas(container.firstChild, {
            backgroundColor: "#ffffff",
            logging: false,
            useCORS: true
        });
    } finally {
        document.body.removeChild(container);
    }
};

export const elementToImage = async (element) => {
    const canvas = await elementToCanvas(element);
    const image = canvas.toDataURL("image/png");
    return { image, width: canvas.width, height: canvas.height };
};

// Descarga con Blob + enlace en vez de abrir una pestaña nueva: despues de
// un await el navegador (sobre todo Safari/iOS) bloquea window.open y la
// accion fallaba sin mostrar nada.
export const downloadElementImage = async (element, filename = "download") => {
    const canvas = await elementToCanvas(element);
    const blob = await canvasToBlob(canvas);
    downloadBlob(blob, `${filename}.png`);
};

export const verifyImageLoads = (url, timeoutMs = 4000) =>
    new Promise((resolve) => {
        const img = new Image();
        const timer = setTimeout(() => resolve(false), timeoutMs);
        img.onload = () => {
            clearTimeout(timer);
            resolve(true);
        };
        img.onerror = () => {
            clearTimeout(timer);
            resolve(false);
        };
        img.crossOrigin = "anonymous";
        img.src = url;
    });
